const { useSelector } = require('react-redux');
const {
  get_configuration_config,
} = require('@managers/remoteConfigurationsManager');
const rolesManager = require('@managers/rolesManager');
const { GLOBAL_SEARCH_CONFIG_NAME } = require('./GlobalSearch.types');

/**
 * Rollout gate for the global search. Open when either:
 *
 * 1. the user is an N-Drip employee — `rolesManager.isNdripUser`, the same
 *    check that gates the Insights tab and the report-issue affordances, or
 * 2. the `global_search` Remote Configuration resolves true for them.
 *
 * `GET /remote_user_configurations` picks the effective config value per
 * caller (users_email[email] > environments[env] > default_value) and returns
 * it as `default_value`; get_configuration_config then lets a farming unit or
 * distribution override refine it further. So customers are opened up per
 * user, farm, distribution or environment from the Remote Configurations page,
 * with no deploy — while employees always have it.
 *
 * For an unknown config name get_configuration_config returns false, so a
 * customer with no configuration gets nothing, which is the correct default.
 */
const useGlobalSearchAccess = () => {
  const email = useSelector(
    (state) => state.authentication_data?.user_details?.email,
  );
  const configurationData = useSelector((state) => state.configuration_data);
  const farmingUnitName = useSelector(
    (state) => state.distribution_data?.selected_entities?.farming_unit?.name,
  );
  const distributionName = useSelector(
    (state) => state.distribution_data?.selected_entities?.distribution?.name,
  );

  if (rolesManager.isNdripUser(email)) {
    return true;
  }
  return Boolean(
    get_configuration_config(
      configurationData ?? {},
      GLOBAL_SEARCH_CONFIG_NAME,
      farmingUnitName,
      distributionName,
    ),
  );
};

module.exports = useGlobalSearchAccess;
